import { getCurrentUser } from '~shared/features/users/selectors/getCurrentUser';
import { isNative } from '~shared/helpers/isNative';

const insuranceSources = {
  onboarding: 'onboarding',
  medDetails: 'med details',
  profile: 'profile',
};
type InsuranceSources = (typeof insuranceSources)[keyof typeof insuranceSources];

export default function getInsuranceSource(state: any): InsuranceSources {
  const currentUser = getCurrentUser(state);

  if (isNative) {
    // insurance source is passed as a prop in native components
    return '';
  }

  const currentRoute = window.location.pathname;

  if (currentRoute.startsWith('/onboard/insurance-input')) {
    return insuranceSources.onboarding;
  }

  if (currentRoute === '/prescriptions') {
    return insuranceSources.medDetails;
  }

  if (currentUser && currentRoute === `/me/${currentUser.id}`) {
    return insuranceSources.profile;
  }

  return '';
}
